// extracted by mini-css-extract-plugin
module.exports = {"root":"Subtitle_root__uyfID"};